export default "__VITE_ASSET__DKJEYYtE__"